module.exports = __webpack_public_path__ + "static/media/clipboard-list-check.8256ba23.svg";